import React, {Component} from "react";
import addIdToCss from '../../utils/addIdToCss';
import shortid from 'shortid'

class HtmlPreview extends Component {
  state = {
    elementId: shortid.generate(),
    styleId: undefined,
    hasStyle: false,
  }

  getElementId = () => `#${this.state.elementId}`

  appendStyle = (cssCode, id) => {
    if (cssCode) {
      const newCss = addIdToCss(cssCode, id);
      if (!newCss.errors) {
        let style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = newCss.code;
        document.getElementsByTagName("head")[0].appendChild(style);

        this.setState({
          styleId: this.getLastStylePositionInHead() - 1,
          hasStyle: true
        })
      }
    }
  }

  changeStyle = (cssCode, id) => {
    const newCss = addIdToCss(cssCode, id);

    if (!newCss.errors) {
      const head = document.getElementsByTagName('head');
      const positionInHead = this.state.styleId;

      head[0].children[positionInHead].innerHTML = newCss.code;
    }
  }

  // Returns the last element added to head
  getLastStylePositionInHead = () => {
    const head = document.getElementsByTagName('head');
    return head[0].children.length;
  }

  componentDidMount() {
    const { cssCode } = this.props;
    const { hasStyle } = this.state;
    const id = this.getElementId();

    if ( cssCode && !hasStyle ) {
      this.appendStyle(cssCode, id)
    }
  }

  componentWillReceiveProps({cssCode}) {
    const { hasStyle } = this.state;
    const id = this.getElementId();

    !hasStyle
      ? this.appendStyle(cssCode, id)
      : this.changeStyle(cssCode, id)
  }

  render() {
    const { code } = this.props;
    const id = this.state.elementId;

    return (
      <div
        id={id}
        className="react-live-preview"
        dangerouslySetInnerHTML={{__html: code}}
      />
    );
  }
}

export default HtmlPreview;



// WEBPACK FOOTER //
// ./src/book/editors/HtmlPreview.js